import { ReactComponent as AngularIcon } from "../icons/angular.svg";
import { ReactComponent as BootstrapIcon } from "../icons/bootstrap.svg";
import { ReactComponent as AspNetIcon } from "../icons/asp-net.svg";
import { ReactComponent as DjangoIcon } from "../icons/django.svg";
import { ReactComponent as EmberIcon } from "../icons/ember.svg";
import { ReactComponent as ExpressjsIcon } from "../icons/expressjs.svg";
import { ReactComponent as FirebaseIcon } from "../icons/firebase.svg";
import { ReactComponent as FlaskIcon } from "../icons/flask.svg";
import { ReactComponent as FlaticonIcon } from "../icons/flaticon.svg";
import { ReactComponent as FontAwesomeIcon } from "../icons/font-awesome.svg";
import { ReactComponent as HerokuIcon } from "../icons/heroku.svg";
import { ReactComponent as IconFinderIcon } from "../icons/icon-finder.svg";
import { ReactComponent as JqueryIcon } from "../icons/jQuery.svg";
import { ReactComponent as NetlifyIcon } from "../icons/netlify.svg";
import { ReactComponent as NextJsIcon } from "../icons/nextjs.svg";
import { ReactComponent as NodejsIcon } from "../icons/nodejs.svg";
import { ReactComponent as RailsIcon } from "../icons/rails.svg";
import { ReactComponent as ReactIcon } from "../icons/react.svg";
import { ReactComponent as StackOverflowIcon } from "../icons/stack-overflow.svg";
import { ReactComponent as SvelteIcon } from "../icons/svelte.svg";
import { ReactComponent as VueIcon } from "../icons/vue.svg";
import { ReactComponent as SemanticUIIcon } from "../icons/semantic-ui.svg";
import { ReactComponent as BackboneIcon } from "../icons/backbonejs.svg";
import { ReactComponent as UnsplashIcon } from "../icons/unsplash.svg";
import { ReactComponent as FreePikIcon } from "../icons/freepik.svg";
import { ReactComponent as WVLIcon } from "../icons/worldvectorlogo.svg";
import { ReactComponent as GithubIcon } from "../icons/github.svg";
import { ReactComponent as HashnodeIcon } from "../icons/hashnode.svg";
import { ReactComponent as QuoraIcon } from "../icons/quora.svg";
import { ReactComponent as RedditIcon } from "../icons/reddit.svg";
import { ReactComponent as MozillaIcon } from "../icons/mozilla-dev-network.svg";
import { ReactComponent as OcticonsIcon } from "../icons/octicons.svg";
import { ReactComponent as MaterialIcon } from "../icons/material-icons.svg";
import { ReactComponent as SurgeIcon } from "../icons/surge.svg";
import { ReactComponent as VercelIcon } from "../icons/vercel.svg";
import { ReactComponent as AzureIcon } from "../icons/azure.svg";
import { ReactComponent as AwsIcon } from "../icons/aws.svg";
import { ReactComponent as DigitalOceanIcon } from "../icons/digital-ocean.svg";
import { ReactComponent as GoogleAppEngineIcon } from "../icons/google-app-engine.svg";

const RCmap = {
    angular: AngularIcon,
    "asp-net": AspNetIcon,
    bootstrap: BootstrapIcon,
    django: DjangoIcon,
    ember: EmberIcon,
    expressjs: ExpressjsIcon,
    firebase: FirebaseIcon,
    flask: FlaskIcon,
    flaticon: FlaticonIcon,
    "font-awesome": FontAwesomeIcon,
    heroku: HerokuIcon,
    "icon-finder": IconFinderIcon,
    jQuery: JqueryIcon,
    netlify: NetlifyIcon,
    nextjs: NextJsIcon,
    nodejs: NodejsIcon,
    rails: RailsIcon,
    react: ReactIcon,
    "stack-overflow": StackOverflowIcon,
    svelte: SvelteIcon,
    vue: VueIcon,
    "semantic-ui": SemanticUIIcon,
    backbonejs: BackboneIcon,
    unsplash: UnsplashIcon,
    worldvectorlogo: WVLIcon,
    freepik: FreePikIcon,
    github: GithubIcon,
    hashnode: HashnodeIcon,
    quora: QuoraIcon,
    reddit: RedditIcon,
    "mozilla-dev-network": MozillaIcon,
    octicons: OcticonsIcon,
    "material-icons": MaterialIcon,
    surge: SurgeIcon,
    vercel: VercelIcon,
    azure: AzureIcon,
    aws: AwsIcon,
    "digital-ocean": DigitalOceanIcon,
    "google-app-engine": GoogleAppEngineIcon,
};

export default RCmap;
